import React from 'react';
import {Create, Datagrid, Edit, List, SimpleForm, TextField, TextInput, Filter, AutocompleteInput, ReferenceInput} from 'react-admin';
import exporterCommon from "../import/exporterCommon";
import DefaultListActions, {Empty} from "./common";

const CostCenterFilter = (props) => (
    <Filter {...props}>
        <ReferenceInput perPage={1000} label="Cost Center Name" emptyText="All Cost Centers" allowEmpty source="id" reference="costCenters" alwaysOn >
            <AutocompleteInput allowEmpty={true} optionText="name" options={{ type: 'search' }} />
        </ReferenceInput >
        {/* Add ReferenceInput + AutocompleteInput here for related fields if needed */}
    </Filter>
)

export const CostCenterList= props => (
    <List  empty={<Empty />}  exporter={exporterCommon(props.resource)} actions={<DefaultListActions/>} {...props} filters={<CostCenterFilter />} >
        <Datagrid rowClick="edit">
            {/*<TextField source="id" />*/}
            <TextField source="code" />
            <TextField source="name" />
            <TextField source="unit" />

            <TextField source="description" />
        </Datagrid>
    </List>
);

export const  CostCenterEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput source="code" />
            <TextInput source="name" />
            <TextInput source="unit" />

            <TextInput source="description" />
        </SimpleForm>
    </Edit>
);

export const  CostCenterCreate = props => (
    <Create {...props}  >
        <SimpleForm redirect='list' >
            <TextInput source="code" />
            <TextInput source="name" />
            <TextInput source="unit" />
            <TextInput source="description" />
        </SimpleForm>
    </Create>
);
